import * as angular from "angular";
import { SwissResultController } from "./SwissResult";
import { ngLeague } from "ng-league/module";

export let playResult = angular.module("play.result", [ngLeague.name]);
playResult.controller("SwissResultCtrl", SwissResultController as any);
